import { render, staticRenderFns } from "./MigrateLocalStorage.vue?vue&type=template&id=9ba671f8&"
import script from "./MigrateLocalStorage.vue?vue&type=script&lang=js&"
export * from "./MigrateLocalStorage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports